import React from "react";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const SortProblems = props => {
    return (
        <>
            <Autocomplete
                noOptionsText="Ingen problematikker fundet"
                id="existing-problem"
                style={{ width: "100%" }}
                options={props.problems}
                onChange={(event, problem) => props.onChange(problem)}
                renderInput={params => (
                    <TextField
                        {...params}
                        inputProps={{
                            ...params.inputProps,
                            name: Math.random(),
                            autoComplete: "new-password"
                        }}
                        label="Vælg problematik"
                        variant="outlined"
                    />
                )}
            />
        </>
    );
};
export default connect(state => state, null, null, { forwardRef: true })(SortProblems);
